import React, {memo, useCallback, useState, useEffect} from 'react';

import Event from './event';
import style from './events-list.module.scss';
import { styleMods } from '../../utils';

const Entry = memo(
	/**
	 * @param {{
	 *   visible: boolean,
	 *   event: import("../../utils/events").Event,
	 *   hashOpenedEventId: null | string,
	 *   dataVersion: number,
	 *   hidable?: boolean,
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function Entry({
		visible,
		event,
		hashOpenedEventId,
		dataVersion,
		hidable = false,
	}) {
		const [hidVisible, setHidVisible] = useState(false);

		useEffect(
			() => {
				if (hidable && event.id === hashOpenedEventId) {
					setHidVisible(true);
				}
			},
			[hidable, hashOpenedEventId, event.id ],
		);

		const toggleVisible = useCallback(
			() => {
				setHidVisible((prev) => !prev);
			},
			[]
		);

		const content = (
			<Event
				event={event}
				visible={hidable ? hidVisible : visible}
				hashOpenedEventId={hashOpenedEventId}
				dataVersion={dataVersion}
				toggleVisible={hidable ? toggleVisible : undefined}
			/>
		);

		if (hidable) {
			return content;
		} else {
			return (
				<li key={event.id} className={style.item}>
					{content}
				</li>
			);
		}
	}
);

/**
 * `visible` is ignored if `hidable` is `true`.
 */
const EventsList = memo(
	/**
	 * @param {{
	 *   visible: boolean,
	 *   events: Array<import("../../utils/events").Event>,
	 *   hashOpenedEventId: null | string,
	 *   dataVersion: number,
	 *   hidable?: boolean,
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function EventsList({
		visible,
		events,
		hashOpenedEventId,
		dataVersion,
		hidable = false,
	}) {
		if (hidable) {
			return (
				<div className={styleMods(style, 'base', 'hidable')}>
					{events.map((event) => (
						<Entry
							event={event}
							visible={visible}
							hashOpenedEventId={hashOpenedEventId}
							dataVersion={dataVersion}
							hidable={true}
						/>
					))}
				</div>
			);
		} else {
			return (
				<ol className={style.base}>
					{events.map((event) => (
						<Entry
							event={event}
							visible={visible}
							hashOpenedEventId={hashOpenedEventId}
							dataVersion={dataVersion}
							hidable={false}
						/>
					))}
				</ol>
			);
		}
	}
);
export default EventsList;
